// src/pages/Users/Distributors.jsx
import React from 'react';
import UserManagement from './UserManagement';

const Distributors = () => {
  return <UserManagement role="distributor" title="Distributor" />;
};

export default Distributors;